import styled, { css } from 'styled-components';
import { Button } from 'components/core';

export const PillsContainer = styled.div`
  display: flex;
  overflow: scroll;
  padding-left: 16px;

  > :last-child {
    padding-right: 25px;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Container = styled.div`
  display: flex;
  margin-top: 40px;
  width: 100%;
`;

export const SubcategoryPillContainer = styled.div`
  margin-right: 8px;
`;

const selectedStyles = css`
  background-color: ${({ theme }) => theme.colors.grey[80]};
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
`;

export const SubcategoryPillButton = styled(Button)<{ selected?: boolean }>`
  border-radius: 9999px;
  text-transform: capitalize;
  white-space: nowrap;
  font-size: 12px;
  height: 35px;
  padding: 11px 15px;
  color: ${({ theme }) => theme.colors.grey[30]};
  background-color: ${({ theme }) => theme.colors.blueGrey[95]};
  ${({ selected }) => selected && selectedStyles}
`;
